/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { usePageInfo } from 'bundles/unified-description-page-common/contexts/PageInfoContext';
import ProgramsFromRoleRenderer from 'bundles/unified-description-page-common/module-renderers/ProgramsFromRoleRenderer';
import RelatedSpecializationSkillsModuleRenderer from 'bundles/unified-description-page-common/module-renderers/RelatedSpecializationSkillsModuleRenderer';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';

type Props = {
  pageData: ConsumerSpecializationPageFieldsFragment;
};

const DiscoveryRecommendationsModuleRenderer = ({ pageData }: Props) => {
  const { navigationIdMap } = usePageInfo();
  return (
    <div
      css={css`
        margin-top: calc(-1 * var(--cds-spacing-600));
      `}
    >
      <Section anchorId={navigationIdMap?.RECOMMENDATIONS} spacing={0}>
        <ProgramsFromRoleRenderer pageData={pageData} />
        <RelatedSpecializationSkillsModuleRenderer pageData={pageData} />
      </Section>
    </div>
  );
};

export default DiscoveryRecommendationsModuleRenderer;
